import React, { memo } from 'react';
import classNames from 'classnames';
import EmojiPopupEmojiButton from '../components/EmojiPopupEmojiButton';
import { getCompleteEmojiCode, getUnified, isTitleRow } from '../emojiPopupUtil';
import { areEqual } from 'react-window';
import { Emoji, EmojisRowData } from '../../emojiTypes';
import { translateCategory } from '../emojiCategoryTranslations';

import { useTranslator } from "../../../i18n/useTranslator";

type EmojiPopupRowProps = {
    style: React.CSSProperties;
    index: number;
    data: {
        rows: EmojisRowData;
        skinTone: string;
        selectedEmojiIds: string[];
        handleClickEmoji: (emoji: Emoji) => void;
        gridSize: number;
        emojiButtonSize?: number;
    };
};

type EmojiPopupRowTitleProps = {
    style: React.CSSProperties;
    title: string;
    isFirst: boolean;
};

const EmojiPopupRowTitle: React.FC<EmojiPopupRowTitleProps> = ({ style, title, isFirst }) => {
    const translate = useTranslator('popup', 'emoji.menu');
    const translatedTitle = translateCategory(title, translate);

    return (
        <div style={style} className={classNames('emoji-list-row title', { first: isFirst })}>
            <h2>{translatedTitle}</h2>
        </div>
    );
};

const EmojiPopupRow = memo(function EmojiPopupRow({
    style,
    index,
    data: { rows, skinTone, selectedEmojiIds, handleClickEmoji, gridSize, emojiButtonSize },
}: EmojiPopupRowProps) {
    const row = rows[index];

    if (isTitleRow(row)) {
        return <EmojiPopupRowTitle style={style} title={row.title} isFirst={index === 0} />;
    }

    return (
        <div style={{ ...style, display: 'flex' }} className="emoji-list-row emojis">
            {row.emojis.map((emoji: Emoji) => (
                <EmojiPopupEmojiButton
                    key={getUnified(emoji)}
                    emoji={emoji}
                    emojiButtonSize={emojiButtonSize}
                    gridSize={gridSize}
                    selected={selectedEmojiIds.indexOf(getCompleteEmojiCode(emoji, skinTone)) > -1}
                    skinTone={skinTone}
                    onClickFn={() => handleClickEmoji(emoji)}
                />
            ))}
        </div>
    );
}, areEqual);

export default EmojiPopupRow;
